//      
                                              
import getMaxScroll from '../../state/get-max-scroll';
import getDocumentElement from '../get-document-element';

export default ()           => {
  const doc              = getDocumentElement();

  const maxScroll           = getMaxScroll({
    // unclipped padding box, with scrollbar
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    // clipped padding box, without scrollbar
    width: doc.clientWidth,
    height: doc.clientHeight,
  });

  return maxScroll;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/window/get-max-window-scroll.js